import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useNewCapability } from 'sharedHooks';
import { filterAndFormatCMDAssets, getFormattedAsset } from './helpers';
import { EventLogs } from './EventLogs';
import { EventLogFilter } from './EventLogFilter';
import { EventDetailsSS } from './EventDetails/EventDetailsSS';
import { EventDetailsCMD } from './EventDetails/EventDetailsCMD';
import { apiCallStatus } from 'helpers/constants';


const EventLogComponent = (props) => {
    const capability = useNewCapability();
    const isSmartSensor = capability.isSmartSensor();

    const {
        generalFilteredAssets,
        selectedAsset,
        selectedOrganization,
        isExpanded,
        assetCapabilityLoadingStatus
    } = props.model;

    const {
        loadCapabilitiesForAssets,
        setSelectedAssets,
        setSelectedEvent,
        setIsExapnded,
    } = props.actions;

    const [eventPage, setEventPage] = useState(1);
    const selectedEventCategoryRef = useRef(null);
    const [eventItemPage, setEventItemPage] = useState(1);
    const selectedEventItemPageRef = useRef(null);

    useEffect(() => {
        generalFilteredAssets?.length && !isSmartSensor &&
            loadCapabilitiesForAssets(selectedOrganization?.organizationID, filterAndFormatCMDAssets(generalFilteredAssets));
    }, [generalFilteredAssets]);

    useEffect(() => {
        setSelectedAssets([getFormattedAsset(selectedAsset)]);
    }, [selectedAsset]);

    const handleSelectedPage = (page) => {
        setEventPage(page);
    };

    const handleSelectedEventItemPage = (pageItem) => {
        setEventItemPage(pageItem);
    };

    const handleSelectEventDetailPage = (page, selectedEvent, selectedEventItemPage) => {
        setEventPage(page);
        if (selectedEvent) {
            selectedEventCategoryRef.current = selectedEvent;
        }
        if (selectedEventItemPage) {
            selectedEventItemPageRef.current = selectedEventItemPage;
        }
    };

    const renderEventDetails = () => {
        return isSmartSensor ?
            <EventDetailsSS
                {...props}
                setSelectedEvent={setSelectedEvent}
                setSelectedEventPage={handleSelectEventDetailPage}
                eventPage={eventPage}
                eventItemPage={eventItemPage}
            />
            :
            <EventDetailsCMD
                {...props}
                setSelectedEvent={setSelectedEvent}
                setSelectedEventPage={handleSelectEventDetailPage}
                eventPage={eventPage}
                eventItemPage={eventItemPage}
            />;
    };


    return (
        <div className='event-log-content'>
            {!props.model.selectedEvent ?
                <>
                    <EventLogFilter {...props}
                        isSS={isSmartSensor}
                        setSelectedAssets={setSelectedAssets}
                        setIsExapnded={setIsExapnded}
                    />
                    {assetCapabilityLoadingStatus !== apiCallStatus.LOADING && <EventLogs
                        {...props}
                        isSS={isSmartSensor}
                        setSelectedEvent={setSelectedEvent}
                        setIsExapnded={setIsExapnded}
                        isExpanded={isExpanded}
                        assistanceCapability={
                            capability.hasAssistancePageCapability()
                        }
                        setSelectedEventPage={handleSelectedPage}
                        selectedEventPage={eventPage}
                        selectedEventCategory={selectedEventCategoryRef.current}
                        setSelectedEventItemPage={handleSelectedEventItemPage}
                        selectedEventItemPage={selectedEventItemPageRef.current}
                    />}
                </>
                : renderEventDetails()
            }
        </div>
    );
};

EventLogComponent.propTypes = {
    actions: PropTypes.shape({
        setSelectedEvent: PropTypes.func, // Function to set the selected event
        loadCapabilitiesForAssets: PropTypes.func, // Function to load capabilities for assets
        setSelectedAssets: PropTypes.func, // Function to set selected assets
        setIsExapnded: PropTypes.func, // Function to set the expanded state
    }), // Actions object containing functions
    asset: PropTypes.any, // Asset details (can be any type)
    model: PropTypes.shape({
        selectedAsset: PropTypes.shape({
            id: PropTypes.string, // Asset ID
            name: PropTypes.string, // Asset name
        }), // Selected asset details
        selectedOrganization: PropTypes.shape({
            organizationID: PropTypes.string, // Organization ID
            name: PropTypes.string, // Organization name
        }), // Selected organization details
        selectedEvent: PropTypes.object, // Selected event details
        generalFilteredAssets: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string, // Asset ID
                name: PropTypes.string, // Asset name
            })
        ), // Array of filtered assets
        isExpanded: PropTypes.bool, // Whether the component is expanded
        assetListCapabilityLoadingStatus: PropTypes.string, // Loading status for asset list capabilities
        assetCapabilityLoadingStatus: PropTypes.string, // Loading status for asset capabilities
    }), // Model containing state data
};


export default EventLogComponent;
